'use client'
import { RootState } from '@/app/globalRedux/store'
import useLoginRouter from '@/app/hooks/useLoginRouter'
import { useTranslation } from '@/app/i18n/client'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import Image from 'next/image'
import { usePathname, useRouter } from 'next/navigation'
import { useState } from 'react'
import { useSelector } from 'react-redux'
export interface CompanyBlockerProps {
  access_count: number
  isBeneficiary: boolean | null
  accessPer: string
}
const CompanyBlocker: React.FC<CompanyBlockerProps> = ({
  access_count,
  isBeneficiary,
  accessPer,
}) => {
  const plan = useSelector((state: RootState) => state.user.userSubscription)
  const loggedIn = useSelector((state: RootState) => state?.user?.loggedIn)
  const { t } = useTranslation()
  const [openCompanyBlocker, setCompanyBlocker] = useState<boolean>(true)
  const router = useRouter()
  const navigateToLogin = useLoginRouter()
  const pathName = usePathname()
  const lng = pathName?.split('/')?.[1]

  const redirectCompanyProfile = () => {
    if (openCompanyBlocker) {
      setCompanyBlocker(false)
      router.push('/search/company-tab')
    }
  }
  return (
    <Dialog
      open={openCompanyBlocker}
      onOpenChange={() => {
        redirectCompanyProfile()
      }}
    >
      <DialogContent
        className=" !w-[30%] border-2  border-[#ededed] py-[20px] items-center justify-center p-0 mobile-width bg-white"
        hideCloseIcon={true}
      >
        <div className=" flex flex-col w-full p-5 mobile-width">
          <div className=" mobile-width flex  flex-col justify-center items-center  gap-5 p-6 w-full">
            {/* Warning Icon and Title */}
            <div className=" flex flex-row gap-2">
              <Image
                height={17.5}
                width={18.9}
                alt="Warning-Icon"
                src={'/assets/Icons/WarningIcon.svg'}
              />
              <div className="text-[20px] text-[#222222] font-bold ">
                {t('Your limit exhausted')}!
              </div>
            </div>
            {/* Message for Logged-in Users */}
            {loggedIn ? (
              <p className="text-[14px] text-[#6f6f6f] text-center ">
                {plan !== 'Platinum'
                  ? t(
                      'Upgrade to unlock more premium features and benefits or wait for renewal'
                    )
                  : t('Kindly wait for renewal of quota')}
              </p>
            ) : (
              ''
            )}
            {/* Plan Information */}
            <div className=" flex flex-col">
              {!loggedIn ? (
                <p className="text-[14px] text-[#222222] ml-1 gap-[1px] font-bold">
                  {t('Login to access this feature')}
                </p>
              ) : (
                <div className="grid grid-cols-[auto,1fr] gap-4">
                  <div className="flex flex-col gap-3 text-[14px] text-[#6f6f6f]">
                    <p>{t('Current plan')}:</p>
                    <p>{t('Limit')}:</p>
                  </div>
                  <div className="flex flex-col gap-3 text-[14px] font-bold ">
                    <p className="text-black">{t(plan)}</p>
                    <p className="text-[#222222]">{`${access_count} ${accessPer == 'weekly' ? t('Companies profiles / Week') : t('Companies Profiles Permanently')}`}</p>
                  </div>
                </div>
              )}
              {/* Beneficiary Restriction */}
              {isBeneficiary !== true &&
              !['Sliver', 'Free'].includes(plan) &&
              loggedIn ? (
                <>
                  <p className="text-[14px] text-red-500 ml-1 gap-[1px] font-bold">
                    {t('You must be a beneficiary to access this content')}
                  </p>
                </>
              ) : (
                ''
              )}
            </div>
            {loggedIn ? (
              plan !== 'Platinum' && (
                <Button
                  variant="secondary"
                  size="sx"
                  className="mt-4 py-3 text-[14px] font-bold"
                >
                  <a href={`/${lng}/solutions/for_buyers`}>{t('UPGRADE')}</a>
                </Button>
              )
            ) : (
              <Button
                variant="secondary"
                size="sx"
                onClick={() => {
                  navigateToLogin('login')
                }}
              >
                {t('LOGIN')}
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default CompanyBlocker
